<template lang="pug">

  section.car
    h3 {{carmodel}}
    img(:src="carpic")
</template>

<script>
  export default  {
    name: 'car',
    props: {
      carmodel: String,
      carpic: String
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .car {
    position: relative;
    z-index: 2;
    img{
      max-width: 100%;
    }
    h3{
      position: absolute;
      top: 0;
      left: 0;
      font-family: 'Open Sans', sans-serif;
      color: white;
      background-color: black;
      padding: 1rem;
    }
  }
</style>
